import { Component } from './component.js';
import { Icon } from './icon.js';
import { Label } from './label.js';

export class Button extends Component {
  static defaultOptions = {
    componentName: 'Button',
    tagName: 'button',
    enabled: true
  };

  constructor (options) {
    super($.extend({}, Button.defaultOptions, options));

    this.setIcon(this.options.icon);
    this.setLabel(this.options.label);

    if (this.options.primary) this.el.addClass('ca-ui-button-primary');
    else if (this.options.danger) this.el.addClass('ca-ui-button-danger');
    else if (!this.options.enabled) this.setEnabled(false);
  }

  setLabel (label) {
    if (!label) return;

    if (!this.label) {
      this.label = new Label({ text: label });
      this.add(this.label);
    } else this.label.setText(label);
  }

  setIcon (icon) {
    if (!icon) return;

    if (!this.icon) {
      this.icon = new Icon({ icon: icon });
      this.add(this.icon);
    } else this.icon.setIcon(icon);
  }

  setEnabled (enabled) {
    this.el.attr('disabled', !enabled);
  }
}
